import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { ComparisonStepperComponent } from '../comparison-stepper/comparison-stepper.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-comparison-stepper-modal',
  templateUrl: './comparison-stepper-modal.component.html',
  imports: [CommonModule, ComparisonStepperComponent],
  styleUrl: './comparison-stepper-modal.component.scss'
})
export class ComparisonStepperModalComponent implements AfterViewInit {

  @Input()
  id: string;

  @ViewChild(ComparisonStepperComponent, {static: true}) comparisonStepper : ComparisonStepperComponent;

  ngAfterViewInit(): void {
    const myModal = document.getElementById('comparison-wizard');

    myModal.addEventListener('hidden.bs.modal', () => {
      this.comparisonStepper.reset();
    });
    
    // Because this component is declared standalone, the translateService does not have the other
    // languages when the component initializes. So call method to get those keys.
    myModal.addEventListener('show.bs.modal', () => {
      this.comparisonStepper.initTranslationKeys();
    });
  }
}
